import { TbWorld } from 'react-icons/tb'

import { TopMenu } from '../Components/TopMenu'
import { DICTIONARY_SEARCH_FIELDS } from '../Contracts/DictionaryFields'
import { CRM_LIST_COLUMNS, crmListFields } from '../Contracts/CrmListFields'
import { CheckDictionaryPageAccessTask } from '../Tasks/CheckDictionaryPageAccessTask'

import type { IResourceConfig } from '@/Core/Contracts/UI'

/**
 * Довідник «Країни» (сім'я `CrmList`, `SPEC-007` §4).
 *
 * Країни перевізників і маршрутів.
 *
 * Сторінку бачить лише той, кому бек дає створення довідників, тобто
 * адміністратор (`pageConfig.accessFn`, `SPEC-007` §7.1); читати довідник для
 * селектів може кожен.
 */
export const ListCountryResource: IResourceConfig = {
    title: 'Країни',
    fields: crmListFields(),
    table: {
        showColumns: CRM_LIST_COLUMNS,
    },
    filter: {
        includeFields: ['id', 'title'],
    },
    places: {
        top: <TopMenu current="countries" />,
    },
    restUrl: '/services/countries',
    pageUrl: '/settings/countries',
    pageConfig: {
        title: 'Країни',
        icon: <TbWorld />,
        accessFn: CheckDictionaryPageAccessTask,
    },
    settings: {
        searchFields: DICTIONARY_SEARCH_FIELDS,
    },
}
